export function zerofill(val){
    val = parseInt(val);

    if(val <10) return "0"+val;
    else return val+"";
} 

//export const API_URL = "http://localhost:3001/";
// export const API_URL = "http://192.168.21.60:3001/";
export const API_URL = "/";
// export const CMS_URL = "http://123.231.232.178/gdrive/dev/hubert/branches/cms";
export const CMS_URL = "https://system.moorlife.id";
export const THEME_COLOR = "deep-orange accent-3";
export function numberWithCommas(x) {
    if(!x) return 0
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function getDate(date =null){
    if(!date){
        date = new Date();
    }

    return date.getFullYear() + "-" + zerofill(date.getMonth()+1) + "-" + zerofill(date.getDate());
}


export function hexToBase64(str) {
    var bString = "";
    for( var i = 0; i < str.length; i +=2) {
         bString += String.fromCharCode( parseInt( str.substr( i, 2), 16));
    }
    return bString;
}
